import { render, staticRenderFns } from "./LayerColorIcon.vue?vue&type=template&id=362c93c5"
import script from "./LayerColorIcon.vue?vue&type=script&lang=js"
export * from "./LayerColorIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports